import { RobotApi } from 'api/RobotApi'
import clsx from 'clsx'
import Box from 'components/Box/Box'
import MapboxCommon from 'components/MapboxMap/MapboxCommon'
import RobotOnMap from 'components/RobotOnMap/RobotOnMap'
import RobotTypeLabel from 'components/RobotTypeLabel/RobotTypeLabel'
import Title from 'components/Title/Title'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RobotActions } from 'store/actions/robot'
import { selectRobot } from 'store/selectors/robot'
import { TIMEOUT_FETCHING_STATUS } from 'utils/constants'
import { IMapboxElement } from 'utils/interfaces'

import RobotImage from './RobotLeftBlock/RobotImage/RobotImage'
import RobotLeftBlock from './RobotLeftBlock/RobotLeftBlock'

import style from './RobotView.module.css'
import pageLayoutStyle from 'styles/pageLayout.module.css'

const RobotView = () => {
  const { t } = useTranslation()
  const robot = useSelector(selectRobot)
  const mapRef = useRef<IMapboxElement>(null)
  const dispatch = useDispatch()

  useEffect(() => {
    const interval = setInterval(async () => {
      if (robot.robotInfo) {
        try {
          const newRobot = await RobotApi.fetchRobot(robot.robotInfo.id)
          dispatch(RobotActions.setRobotInfo(newRobot))
        } catch (error) {
          // Silently handle network errors (ERR_NETWORK_CHANGED, Failed to fetch, etc.)
          // These are common when network connection is unstable and don't need user attention
          if (error instanceof TypeError && error.message === 'Failed to fetch') {
            // Network error - silently ignore, will retry on next interval
            return
          }
          // Log other errors but don't break the update cycle
          console.warn('[RobotView] Error fetching robot data:', error)
        }
      }
    }, TIMEOUT_FETCHING_STATUS)
    return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [robot.robotInfo?.id])

  return (
    <>
      <div className={pageLayoutStyle.pageHeaderArea}>
        <div className={clsx(style.titleBlock, pageLayoutStyle.titleBlockMargin)}>
          <div className={style.titleImage}>
            <RobotImage />
          </div>
          <Title text={robot.robotInfo?.name || ''} />
          <div className={clsx('text-16-300', style.titleId)}>
            {t('robot.serial_number')}: {robot.robotInfo?.serialNumber}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'flex-start' }}>
          <RobotTypeLabel vendor={robot.robotInfo?.vendor} robotType={robot.robotInfo?.robot_type} />
        </div>
      </div>
      <div className={style.main}>
        <div className={style.leftBlock}>
          <Box className={style.box}>
            <RobotLeftBlock />
          </Box>
        </div>
        <div className={style.map}>
          <MapboxCommon ref={mapRef}>
            <RobotOnMap map={mapRef.current?.getMap()} />
          </MapboxCommon>
        </div>
      </div>
    </>
  )
}
export default RobotView
